import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarFormaPagamentoRecebimento, setModalDeletarFormaPagamentoRecebimento } from "../redux/slices/formaPagamentoRecebimento/formaPagamentoRecebimentoSlice";

export const cadastrarFormaPagamentoRecebimento = createAsyncThunk("/FormaPagamentoRecebimento/CadastrarFormaPagamentoRecebimento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/FormaPagamentoRecebimento/CadastrarFormaPagamentoRecebimento", payload.value);
    toastSucess("Forma de pagamento cadastrada com sucesso");
    dispatch(setModalCadastrarFormaPagamentoRecebimento(false));
    dispatch(setLoading(false));

    dispatch(buscarFormaPagamentoRecebimento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarFormaPagamentoRecebimento = createAsyncThunk("/FormaPagamentoRecebimento/BuscarFormaPagamentoRecebimento", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/FormaPagamentoRecebimento/BuscarFormaPagamentoRecebimento", { params: { pesquisar: pesquisar } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});


export const atualizarFormaPagamentoRecebimento = createAsyncThunk("/FormaPagamentoRecebimento/AtualizarFormaPagamentoRecebimento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/FormaPagamentoRecebimento/AtualizarFormaPagamentoRecebimento", payload.value);
    toastSucess("Forma de pagamento atualizada com sucesso");
    dispatch(setModalCadastrarFormaPagamentoRecebimento(false));
    dispatch(setLoading(false));

    dispatch(buscarFormaPagamentoRecebimento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarFormaPagamentoRecebimentoAtivo = createAsyncThunk("/FormaPagamentoRecebimento/AtualizarFormaPagamentoRecebimentoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/FormaPagamentoRecebimento/AtualizarFormaPagamentoRecebimentoAtivo", null, { params: payload.value });
    toastSucess("Statu de ativo da Forma de pagamento atualizada com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarFormaPagamentoRecebimento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarFormaPagamentoRecebimento = createAsyncThunk("/FormaPagamentoRecebimento/DeletarFormaPagamentoRecebimento", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/FormaPagamentoRecebimento/DeletarFormaPagamentoRecebimento", { params: { id: payload.value } });
    toastSucess("Forma de pagamento removida com sucesso");
    dispatch(setModalDeletarFormaPagamentoRecebimento(false));
    dispatch(setLoading(false));

    dispatch(buscarFormaPagamentoRecebimento(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
